<script lang="ts">
	import { run } from "svelte/legacy"

	/**
	 * We need a better way to retrieve all of the active devices
	 *
	 */
	import {
		DataHandlerDeviceAdmin,
		DeviceAdmin,
		type Device,
		type DeviceAdminRawData,
		type DeviceRawData,
	} from "luxedo-data"
	import { LuxedoRPC } from "luxedo-rpc"
	import { onMount } from "svelte"
	import { Toast } from "toaster"
	import Header from "../../reusable/Header.svelte"
	import LoadingSpinner from "../../reusable/loaders/LoadingSpinner.svelte"
	import DeviceTable from "./DeviceTable.svelte"

	let pageDevices: Array<
		DeviceRawData | DeviceAdminRawData | Device | DeviceAdmin
	> = $state([])

	let pageAmount = $state(0)
	let pageNumber = $state(0)

	let isLoading = $state(true)

	async function searchDevices(searchInput: string) {
		if (searchInput) {
			isLoading = true
		} else return updateDeviceList()

		const id = Number(searchInput)
		if (isNaN(id)) {
			Toast.error("Must provide a valid number.")
			return updateDeviceList()
		}

		await DataHandlerDeviceAdmin.pull([id])

		const allDevices = DataHandlerDeviceAdmin.getMany([id])
		pageDevices = allDevices

		if (allDevices.length === 0) Toast.error("No devices found.")

		isLoading = false
	}

	function navigatePage(goBack: boolean) {
		if (goBack) pageNumber--
		else pageNumber++
	}

	async function updateDeviceList() {
		isLoading = true
		const res = await LuxedoRPC.api.admin.get_devices_by_page(pageNumber)
		pageDevices = Object.values(res.data)
		pageAmount = res.total
		isLoading = false
	}

	onMount(updateDeviceList)

	run(() => {
		pageNumber > -1 && updateDeviceList()
	})
</script>

<!-- onSearch={searchDevices} -->

<Header
	heading="Device List"
	onNavigate={navigatePage}
	{pageAmount}
	onSearch={searchDevices}
	bind:pageNumber
/>
{#if isLoading}
	<main>
		<LoadingSpinner loadingText="Loading devices" />
	</main>
{:else if pageDevices.length > 0}
	<DeviceTable devices={pageDevices} />
{/if}

<style>
	main {
		--loader-color: var(--color-accent);
		--loader-width: 20vw;

		width: 100%;
		height: calc(100vh - var(--header-height));
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
</style>
